import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import  ToyOrderHistory  from "./ToyOrderHistory";

import { PER_USDT_TO_BNB } from "../contracts/contracts";
import useContract from "../hooks/useContract";
import {
  useAppKit,
  useAppKitAccount,
  useAppKitNetwork,
} from "@reown/appkit/react";
import ClipLoader from "react-spinners/ClipLoader";
import { FaTelegramPlane, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import styled from "styled-components";

import { PRESALE_CONTRACT_ADDRESS, PRESALE_ABI } from "../contracts/contracts";
import { JsonRpcProvider, Contract, formatUnits } from "ethers";
import dayjs from 'dayjs';
import { ethers } from "ethers";
import { TOKEN_CONTRACT_ADDRESS,TOKEN_ABI } from "../contracts/contracts";

import "./boxstyle.css";

export const ProfileOverview = () => {
     const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();



  
  const [referralLink, setReferralLink] = useState("");
  const [referrer, setReferrer] = useState(null);

  const [copySuccess, setCopySuccess] = useState("");

  const {getReferralCount , getReferralRewards ,claimRefTokens ,getTotalClaimedRewards ,claimStakingTokens ,getTotalUnclaimedReward ,useSaveUserData ,transferTokens} = useContract();

  const [referralCount, setReferralCount] = useState("0");
const [referralReward, setReferralReward] = useState("0");
const [claimLoading, setClaimLoading] = useState(false);

   const [error, setError] = useState(null); // State for any errors
  
useEffect(() => {
  if (!address || !isConnected) return;

  const fetchVestingData = async () => {
    try {

      const referralCount = await getReferralCount(address);
      setReferralCount(referralCount.toString());

      const referralReward = await getReferralRewards(address);
      setReferralReward(referralReward.toString());
    } catch (error) {
      console.error("Error fetching vesting data:", error.message || error);
      setError(error.message || "Failed to fetch vesting data.");
    }
  };

  fetchVestingData();
}, [address, isConnected]);






const [totalClaimedRewards, setTotalClaimedRewards] = useState("0");



useEffect(() => {
  if (!address || !isConnected) return;

  const fetchStakingData = async () => {
    try {
      const claimedRewards = await getTotalClaimedRewards(address);
      setTotalClaimedRewards(claimedRewards.toString());
    } catch (error) {
      console.error("Error fetching staking data:", error.message || error);
      setError(error.message || "Failed to fetch staking data.");
    }
  };

  fetchStakingData(); // Run once on mount

  const interval = setInterval(fetchStakingData, 20000); // Every 20 sec

  return () => clearInterval(interval); // Cleanup on unmount or dependency change
}, [address, isConnected]);







const [totalUnclaimedReward, setTotalUnclaimedReward] = useState("0");






useEffect(() => {
  if (!address || !isConnected) return;

  const fetchUnclaimedAmount = async () => {
    try {
      const unclaimedRewards = await getTotalUnclaimedReward(address);
      setTotalUnclaimedReward(unclaimedRewards.toString());
    } catch (error) {
      console.error("Error fetching staking data:", error.message || error);
      setError(error.message || "Failed to fetch staking data.");
    }
  };

  fetchUnclaimedAmount();
}, [address, isConnected]);




  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const ref = queryParams.get("ref");
    if (ref) {
      setReferrer(ref); // Store the referrer address
    }
  }, []);
  

useEffect(() => {
  if (address) {
    setReferralLink(`${window.location.origin}/presale?ref=${address}`);
  }
}, [address]);


  const copyReferral = async () => {
    if (!referralLink) {
      toast.warning("Please connect your wallet first.");
      return;
    }
    try {
      await navigator.clipboard.writeText(referralLink);
      toast.success("Referral link copied!");
    } catch {
      toast.error("Copy not supported.");
    }
  };

  const handleShare = async () => {
    if (navigator.share && referralLink) {
      try {
        await navigator.share({
          title: "Join BabyUnicorn!",
          text: "Earn rewards by joining via my referral link:",
          url: referralLink,
        });
      } catch (error) {
        toast.error("Share cancelled.");
      }
    } else {
      toast("Sharing not supported on this device.");
    }
  };
  




  // Claim tokens
const handleClaimRefTokens = async () => {
  setClaimLoading(true);
  try {
    await claimRefTokens();
    toast.success("Claim Successful");

  } catch (err) {
    console.error(err);

    let errorMessage = "Error Claiming";

    if (err?.reason) {
      errorMessage = err.reason;
    } else if (err?.error?.message) {
      errorMessage = err.error.message;
    } else if (err?.data?.message) {
      errorMessage = err.data.message;
    } else if (err?.message) {
      errorMessage = err.message;
    }

    toast.error(errorMessage); // Show as warning with specific reason
  }
  setClaimLoading(false);
};



const [stakingLoading, setStakingLoading] = useState(false);



const handleClaimAllRewards = async () => {
  setStakingLoading(true);
  try {
    await claimStakingTokens(); // Your contract call
    toast.success("All rewards claimed successfully!");
  } catch (err) {
    console.error(err);

    let errorMessage = "Error claiming rewards.";

    if (err?.reason) {
      errorMessage = err.reason;
    } else if (err?.error?.message) {
      errorMessage = err.error.message;
    } else if (err?.data?.message) {
      errorMessage = err.data.message;
    } else if (err?.message) {
      errorMessage = err.message;
    }

    toast.error(errorMessage); // ⬅️ Changed to error
  }
  setStakingLoading(false);
};





   const { getStakeinfo ,myTokenBalance ,maxBalances ,getReferrerOf} = useContract();







const [stakeHistory, setStakeHistory] = useState([]);

useEffect(() => {
  const fetchStakeData = async () => {
    const data = await getStakeinfo();
    if (data) setStakeHistory(data);
  };
  if (isConnected) fetchStakeData();
}, [isConnected, address]);



const [totalStaked, setTotalStaked] = useState(0);

useEffect(() => {
  const fetchStakes = async () => {
    if (!isConnected || !address) return;

    const stakeData = await getStakeinfo();

    if (Array.isArray(stakeData)) {
      setStakeHistory(stakeData);

      // Calculate total staked
      const total = stakeData.reduce(
        (sum, item) => sum + parseFloat(item.amount),
        0
      );
      setTotalStaked(total);
    }
  };

  fetchStakes();
}, [isConnected, address]);



useEffect(() => {
  const fetchStakesAndReferrer = async () => {
    if (!isConnected || !address) return;

    const [stakeData, referrerAddr] = await Promise.all([
      getStakeinfo(),
      getReferrerOf()
    ]);

    if (Array.isArray(stakeData)) {
      setStakeHistory(stakeData);

      const total = stakeData.reduce(
        (sum, item) => sum + parseFloat(item.amount),
        0
      );
      setTotalStaked(total);
    }

    if (referrerAddr && referrerAddr !== "0x0000000000000000000000000000000000000000") {
      setReferrer(referrerAddr);
    }
  };

  fetchStakesAndReferrer();
}, [isConnected, address]);





const formatCompactNumber = (num) => {
  const number = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(number)) return "0";
  if (number >= 1_000_000_000_000) return (number / 1_000_000_000_000).toFixed(2) + "T";
  if (number >= 1_000_000_000) return (number / 1_000_000_000).toFixed(4) + "B";
  if (number >= 1_000_000) return (number / 1_000_000).toFixed(4) + "M";
  if (number >= 1_000) return (number / 1_000).toFixed(4) + "K";
  return number.toFixed(4);
};



    const [maxBalance, setMaxBalance] = useState(null);
    const [balance, setBalance] = useState(0);

    useEffect(() => {
    const _balance = async () => {
      const _myBalance = await myTokenBalance();
      console.log(_myBalance);
      setBalance(_myBalance);
      const _maxBalance = await maxBalances();
      console.log(_maxBalance);
      setMaxBalance(_maxBalance);
    };
    if (address) _balance();
  }, [address]);


  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);





  const { saveUserData } = useSaveUserData();

useEffect(() => {
  saveUserData({
    address,
    isConnected,
    balance,
    totalStaked,
    referralCount,
    referralReward,
    totalClaimedRewards,
    totalUnclaimedReward,
    referrer, // 👈 Add this
  });
}, [
  address,
  isConnected,
  balance,
  totalStaked,
  referralCount,
  referralReward,
  totalClaimedRewards,
  totalUnclaimedReward,
  referrer, // 👈 Add to deps too
]);






  const [showPopup, setShowPopup] = useState(false);
  const [to, setTo] = useState("");
  const [amount, setAmount] = useState("");


const handleTransfer = async () => {
  try {
    if (!to || !amount) {
      toast.error("Please fill both fields.");
      return;
    }

    await transferTokens({
      to,
      amount: ethers.parseUnits(amount, 18), // Adjust decimals if needed
    });

    toast.success("Transfer successful!");
    setShowPopup(false);
    setTo("");
    setAmount("");
  } catch (err) {
    toast.error("Transfer failed: " + (err?.message || err));
  }
};



  return (
    <div className="w-full flex flex-col items-center px-2 md:px-0 py-8">
      {/* Banner */}
      <div
        className="w-full max-w-2xl mb-20 relative shadow-2xl lg:max-w-7xl lg:mb-32"
        style={{ height: '380px' }}
      >
        <div className="w-full h-full rounded-2xl overflow-hidden lg:rounded-[40px] lg:h-full">
          <img
            src="2151800437.png"
            alt="Banner"
            className="w-full h-full object-cover"
          />
        </div>
        {/* Profile Logo */}
        <div className="absolute left-4 bottom-[-48px] z-20 lg:left-24 lg:bottom-[-100px]">
          <div className="w-24 h-24 rounded-full border-4 border-[#231b36] bg-white overflow-hidden shadow-2xl flex items-center justify-center lg:w-60 lg:h-60 lg:border-[12px]">
            <img
              src="img1.png"
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Name and controls */}
      <div className="w-full max-w-2xl flex flex-col md:flex-row items-center justify-between mt-14 mb-10 px-4 lg:max-w-7xl lg:mt-2 lg:mb-16 lg:px-8">
        <div className="flex items-center gap-3 lg:gap-6">
          <span className="text-2xl font-bold text-white lg:text-5xl lg:font-extrabold">   {user?.full_name || "Unnamed User"}</span>
          <span className="ml-2 text-green-400 text-xl lg:ml-4 lg:text-4xl">🦄</span>
        </div>
      <div className="flex gap-5 items-start max-sm:gap-4">
  <a href="https://t.me/BabyUnicornAI" target="_blank" rel="noopener noreferrer">
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/b6d2af109b7c028a21759919d659128dec64a94b"
      alt="Frame 5"
      className="flex gap-1 items-center rounded border-pink-300 border-solid transition-opacity cursor-pointer border-[0.68px] duration-[0.2s] ease-[ease] hover:opacity-80"
    />
  </a>

  <a href="https://x.com" target="_blank" rel="noopener noreferrer">
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/6fa8edb2161dfbd8e6afbb6cc7ececea7de14008"
      alt="Frame 6"
      className="flex gap-1 items-center rounded border-pink-300 border-solid transition-opacity cursor-pointer border-[0.68px] duration-[0.2s] ease-[ease] hover:opacity-80"
    />
  </a>
</div>
      </div>

      {/* Overview and Referral Rewards */}
      <div className="w-full max-w-2xl grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 lg:max-w-7xl lg:gap-16 lg:mb-20">
        {/* Overview Card */}
        <div className="bg-[#2a2540] rounded-2xl p-6 flex flex-col gap-8 shadow-2xl min-h-[250px] lg:rounded-[32px] lg:p-16 lg:gap-14 lg:min-h-[500px]">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-[#bebebe] text-base mb-2 lg:text-2xl lg:mb-4">AVBL. BALANCE</div>
              <div className="text-white text-3xl font-bold lg:text-6xl lg:font-extrabold">
                {formatCompactNumber(balance)} <span className="text-pink-300">$BABYU</span>
              </div>
            </div>
            <div className="w-16 h-16 bg-[#ffd7ed] rounded-full flex items-center justify-center lg:w-44 lg:h-44">
              <img
                src="https://c.animaapp.com/mckus90aOZqDGk/img/freepik--the-style-is-candid-image-photography-with-natural--633.png"
                alt="Token"
                className="w-10 h-14 object-contain lg:w-28 lg:h-32"
              />
            </div>
          </div>
          <div className="flex justify-between">
<div className="mt-4 mb-6">
  <div className="text-[#bebebe] text-base lg:text-2xl">Staked</div>
  <div className="text-white text-xl font-semibold lg:text-3xl lg:font-bold">
    {formatCompactNumber(totalStaked)} BABYU
  </div>
</div>


            <div>
              <div className="text-[#3de03d] text-base lg:text-2xl">Reward Claimed</div>
              <div className="text-white text-xl font-semibold lg:text-3xl lg:font-bold">{totalClaimedRewards}</div>
            </div>
            
          </div>
<div className="mt- lg:mt-">
  {/* Total Unclaimed Reward Header */}
  <div className="flex items-center justify-between text-white text-base lg:text-2xl mb-4 lg:mb-6">
    <span className="text-[#bebebe] font-semibold">Total Unclaimed </span>
      {totalUnclaimedReward !== null && (
      <div className="text-white text-sm font-medium bg-[#3a3350] px-3 py-1 rounded-full">
      Reward Earned  : {formatCompactNumber(totalUnclaimedReward)} BABYU
      </div>
    )}
  </div>

  {/* Action Buttons */}
  <div className="flex gap-4 lg:gap-12">
     <button
          onClick={() => setShowPopup(true)}
          className="flex-1 h-12 lg:h-16 rounded-full font-bold text-base lg:text-2xl border-2 border-white bg-transparent text-white transition hover:bg-white/10"
        >
          TRANSFER
        </button>
    <button
      onClick={handleClaimAllRewards}
      disabled={stakingLoading}
      className={`flex-1 h-12 lg:h-16 rounded-full font-bold text-base lg:text-2xl text-white border-none shadow-lg bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 transition ${
        stakingLoading ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {stakingLoading ? "Claiming..." : "Claim All rewards"}
    </button>
  </div>
</div>


        </div>

        {/* Referral Rewards Card */}
        <div className="bg-[#2a2540] rounded-2xl p-6 flex flex-col gap-8 shadow-2xl min-h-[250px] lg:rounded-[32px] lg:p-16 lg:gap-14 lg:min-h-[500px]">
          <div className="text-white text-2xl font-semibold mb-2 lg:text-4xl lg:font-extrabold lg:mb-4">Referral Rewards</div>
<div>
  <div className="text-[#bebebe] text-base mb-1 lg:text-2xl lg:mb-2">Your Link</div>

  <div className="flex items-center gap-2 bg-[#3a335066] rounded px-4 py-2 mb-2 lg:gap-6 lg:rounded-xl lg:px-10 lg:py-4 lg:mb-6">
    <span className="text-white text-base truncate lg:text-2xl">
      {referralLink || "Connect wallet to get your link"}
    </span>
    {referralLink && (
      <img
        onClick={copyReferral}
        src="https://c.animaapp.com/mckus90aOZqDGk/img/copy.svg"
        alt="Copy"
        className="w-6 h-6 lg:w-10 lg:h-10 cursor-pointer hover:opacity-80 transition"
      />
    )}
  </div>

  {/* BUTTONS: same line text, responsive layout */}
  <div className="flex flex-col gap-3 lg:flex-row lg:gap-4">
    <button
      onClick={handleShare}
      className="flex-1 flex items-center justify-center whitespace-nowrap gap-2 rounded-full px-6 py-3 font-bold text-base text-white border-2 border-white shadow-lg bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 lg:py-4 lg:text-xl"
    >
      <span>Share</span>
      <img
        src="https://c.animaapp.com/mckus90aOZqDGk/img/share-alt.svg"
        alt="Share"
        className="w-5 h-5 lg:w-6 lg:h-6"
      />
    </button>

    <button
      onClick={handleClaimRefTokens}
      className="flex-1 flex items-center justify-center whitespace-nowrap gap-2 rounded-full px-6 py-3 font-bold text-base text-white border-2 border-white shadow-lg bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 lg:py-4 lg:text-xl"
    >
      <span>Claim Rewards</span>
    </button>
  </div>
</div>


          <div className="flex items-center justify-between">
            <div>
              <div className="text-[#bebebe] text-base lg:text-2xl">Referrals</div>
              <div className="text-white text-2xl font-bold lg:text-4xl lg:font-extrabold">{referralCount}</div>
            </div>
            <div>
              <div className="text-[#3de03d] text-base lg:text-2xl">Earned</div>
              <div className="text-white text-2xl font-bold lg:text-4xl lg:font-extrabold">
                {referralReward} <span className="text-lg lg:text-3xl">$BABYU</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Staking History */}
    <div className="w-full max-w-2xl bg-[#2a2540] rounded-2xl p-6 shadow-2xl lg:max-w-7xl lg:rounded-[32px] lg:p-16 frame-sd52">
  <div className="text-2xl font-bold mb-6 lg:text-4xl lg:font-extrabold lg:mb-10">
    <span className="text-pink-400">Staking</span> History
  </div>
  <div className="overflow-x-auto">
    <table className="min-w-full text-left">
<thead>
  <tr className="bg-[#2f2a47] text-white text-lg lg:text-2xl whitespace-nowrap">
    <th className="py-4 px-3 font-bold lg:py-6 lg:px-6">Amount</th>
    <th className="py-4 px-3 font-bold lg:py-6 lg:px-6">Duration</th>
    <th className="py-4 px-3 font-bold lg:py-6 lg:px-6">APY</th>
    <th className="py-4 px-3 font-bold lg:py-6 lg:px-6">Start Date</th>
    <th className="py-4 px-3 font-bold lg:py-6 lg:px-6">End Date</th>
    <th className="py-4 px-3 font-bold lg:py-6 lg:px-6">Status</th>
  </tr>
</thead>


      <tbody>
        {stakeHistory.length === 0 ? (
          <tr>
            <td colSpan="5" className="text-center text-white py-6">
              No staking data found.
            </td>
          </tr>
        ) : (
          stakeHistory.map((item, index) => {
            const now = Math.floor(Date.now() / 1000);
            const isActive = now < item.endTimeUnix;
<td className="py-4 px-3 text-white lg:py-7 lg:px-10">
  {item.endTime}
</td>

            const getDurationLabel = (index) => {
              switch (index) {
                case 1: return "1 Month";
                case 2: return "2 Months";
                case 3: return "3 Months";
                case 4: return "6 Months";
                default: return "-";
              }
            };

            const getApy = (index) => {
              switch (index) {
                case 1: return "12%";
                case 2: return "18%";
                case 3: return "24%";
                case 4: return "36%";
                default: return "-";
              }
            };

            return (
            <tr
  key={index}
  className={`${
    index % 2 === 0 ? "bg-[#2a2540]" : "bg-[#3a3350]"
  } text-lg lg:text-2xl border-b border-[#503564]`}
>
  <td className="py-4 px-3 text-white font-bold lg:py-7 lg:px-10">{item.amount}</td>
  <td className="py-4 px-3 text-white lg:py-7 lg:px-10">
    {getDurationLabel(item.lockupIndex)}
  </td>
  <td className="py-4 px-3 text-white lg:py-7 lg:px-10">
    {getApy(item.lockupIndex)}
  </td>
  <td className="py-4 px-3 text-white lg:py-7 lg:px-10">{item.startTime}</td>
  <td className="py-4 px-3 text-white lg:py-7 lg:px-10">{item.endTime}</td> {/* ⬅️ New */}
  <td className="py-4 px-3 text-white flex items-center gap-2 lg:py-7 lg:px-10 lg:gap-3">
    <img
      src={
        isActive
          ? "https://c.animaapp.com/mckus90aOZqDGk/img/check-circle.svg"
          : "https://c.animaapp.com/mckus90aOZqDGk/img/x-circle.svg"
      }
      alt={isActive ? "Active" : "Ended"}
      className="w-5 h-5 lg:w-8 lg:h-8"
    />
    {isActive ? "Active" : "Ended"}
  </td>
</tr>

            );
          })
        )}
      </tbody>
    </table>
  </div>
</div>


<ToyOrderHistory/>


{showPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-5">
    <div className="w-full max-w-md bg-[#2a2540] rounded-2xl p-6 shadow-2xl lg:rounded-[32px] lg:p-10 frame-sd52 text-white">
      <h2 className="text-2xl font-bold mb-6 text-center text-white">Transfer Tokens</h2>

<div className="frame-11 mb-4">
  <input
    type="text"
    placeholder="Recipient address"
    value={to}
    onChange={(e) => setTo(e.target.value)}
    className="
      w-full bg-transparent border-none outline-none
      text-[#dddddd] text-xs sm:text-base
      placeholder:text-neutral-400
      px-2 py-2
    "
  />
</div>

<div className="frame-11 mb-6">
  <input
    type="number"
    placeholder="Amount"
    value={amount}
    onChange={(e) => setAmount(e.target.value)}
    className="
      w-full bg-transparent border-none outline-none
      text-[#dddddd] text-xs sm:text-base
      placeholder:text-neutral-400
      px-2 py-2
    "
  />
</div>



      <div className="flex justify-end gap-4">
        <button
          onClick={() => setShowPopup(false)}
          className="px-5 py-2.5 rounded-full bg-white/20 hover:bg-white/30 transition text-white"
        >
          Cancel
        </button>
        <button
          onClick={handleTransfer}
          className="px-6 py-2.5 rounded-full bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-white font-semibold hover:opacity-90 transition"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)}





    </div>
  );
};
